import styled, { css } from 'styled-components';
import Slider from 'react-slick';
import { colorWhite, mediaMd, mediaSm } from 'theme/theme-helper-selectors';

export const CircleBase = css`
    width: 130px;
    height: 130px;
    aspect-ratio: 1/1;
    border-radius: 50%;
    background: radial-gradient(
        101.85% 152.6% at 0% 86%,
        rgba(63, 224, 209, 1),
        rgba(76, 179, 254, 1),
        rgba(151, 138, 249, 1)
    );

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: ${colorWhite};
    position: relative;
    overflow: hidden;
    cursor: pointer;
    transition: width 0.3s ease, height 0.3s ease, border-color 0.3s ease;

    &:hover {
        &:before {
            opacity: 1;
        }
    }

    &:before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-radius: 50%;
        background-color: rgba(0, 0, 0, 0.25);
        opacity: 0;
        transition: opacity 0.3s ease;
    }

    @media (${mediaSm}) {
        width: 75px;
        height: 75px;
    }
`;

export const UniCircle = styled.a`
    ${CircleBase};
`;

export const UniCircleDiv = styled.div`
    ${CircleBase};
    display: flex !important;
    justify-content: center;
    align-items: center;

    color: ${colorWhite};
`;

export const UniImage = styled.div<{ imageUrl: string }>`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-image: url(${({ imageUrl }) => imageUrl});
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    width: 100%;
    height: 100%;
`;

export const StyledSlider = styled(Slider)`
    position: relative;
    max-width: 90%;
    margin: 50px auto 0;

    @media (${mediaMd}) {
        margin: 32px auto 0;
    }

    @media (${mediaSm}) {
        max-width: 100%;
        margin: 12px auto 0;
    }

    .slick-track {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 40px 0;
    }

    .slick-slide {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 10px;
    }

    .slick-slide > div {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 167px;
    }

    @media (min-width: 1281px) {
        .slick-slide.slick-active
            + .slick-slide.slick-active
            + .slick-slide.slick-active
            ${UniCircle} {
            width: 167px;
            height: 167px;
        }

        .slick-slide.slick-active
            + .slick-slide.slick-active
            + .slick-slide.slick-active
            + .slick-slide.slick-active
            + .slick-slide.slick-active
            ${UniCircle} {
            width: 130px;
            height: 130px;
        }
    }

    @media (max-width: 1280px) and (min-width: 768px) {
        .slick-slide.slick-active
            + .slick-slide.slick-active
            ${UniCircle},
            .slick-slide.slick-active
            + .slick-slide.slick-active
            + .slick-slide.slick-active
            ${UniCircle} {
            width: 167px;
            height: 167px;
        }

        .slick-slide.slick-active
            + .slick-slide.slick-active
            + .slick-slide.slick-active
            + .slick-slide.slick-active
            ${UniCircle} {
            width: 130px;
            height: 130px;
        }
    }
    .slick-arrow {
        top: 50%;
        transform: translateY(-50%);
        position: absolute;
        z-index: 20;
        width: 50px;
        height: 50px;
        background-color: rgba(255, 255, 255, 0.15);
        border-radius: 50%;
        color: ${colorWhite};
        cursor: pointer;
        font-size: 24px;
        font-family: initial;
        line-height: 1;
        border: none;
        display: flex !important;
        align-items: center;
        justify-content: center;

        &:before {
            display: none;
        }
    }

    .slick-prev {
        left: -60px;
    }

    .slick-next {
        right: -60px;
    }

    @media (${mediaMd}) {
        .slick-prev {
            left: -40px;
        }
        .slick-next {
            right: -40px;
        }
    }

    @media (${mediaSm}) {
        .slick-track {
            padding: 30px 0;
        }

        .slick-slide {
            padding: 0 10px;
        }

        .slick-slide > div {
            height: 97px;
        }

        .slick-slide.slick-active + .slick-slide.slick-active ${UniCircle} {
            width: 97px;
            height: 97px;
        }

        .slick-slide.slick-active
            + .slick-slide.slick-active
            + .slick-slide.slick-active
            ${UniCircle} {
            width: 75px;
            height: 75px;
        }

        .slick-arrow {
            width: 35px;
            height: 35px;
            font-size: 18px;
        }
        .slick-prev {
            left: -30px;
        }
        .slick-next {
            right: -30px;
        }
    }
`;
